import React, { useCallback, useEffect, lazy, Suspense, useState } from 'react';
import { Link, Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Hub } from '@aws-amplify/core';
// import Wallet from '@kambria/kambria-wallet';
import { BlockchainAlert, FollowUs, Header, Nav, NavItem, PageLoader } from '@kambria/kambria-lego';
import Footer from './views/components/Footer';
import Error404 from './views/errors/404';
import NavProfile from 'views/components/core/NavProfile';
import CircleLoader from 'views/components/core/CircleLoader';
import {
  fetchUser,
  linkProvider,
  logInMvp,
  fetchUserMvp,
  mvpRefreshToken,
  getListLanguage,
} from 'redux/actions/user.action';
import { connectWallet, watchInfo } from 'redux/actions/blockchain.action';
import { getKarma } from 'redux/actions/karma.action';
import { getCredits } from 'redux/actions/credit.action';
import config from 'config';
import '@kambria/kambria-lego/build/css/index.css';
import 'static/styles/index.css';
import 'antd/dist/antd.css';
import logo from 'TECD logo 1.png';
import discordIcon from 'static/images/footer/discord.png';
import facebookIcon from 'static/images/footer/facebook.png';
import twitterIcon from 'static/images/footer/twitter.png';
import linkedinIcon from 'static/images/footer/linkedin.png';
import youtubeIcon from 'static/images/footer/youtube.png';
import PrivateRoute from './hooks/privateRoute';
import PrivateRouteSenior from './hooks/privateRouteSenior';
import PrivateRouPrivateRouteBuddy from './hooks/privateRouteBuddy';

import Home from './views/pages/app/Home';
import Login from './views/mvpAuth/SignIn';
import MySession from './views/pages/app/MySession';
import MyTopic from './views/pages/app/MyTopic';
import DetailTopic from './views/pages/app/mvp/topic-detail';
import SessionDetail from './views/pages/app/mvp/session-detail';
import AcceptSession from './views/pages/app/mvp/accept-success-session';
import DeclineSession from './views/pages/app/mvp/decline-success-session';
import SessionVideoCustom from './views/pages/app/mvp/session-video-custom';
import CreateSession from './views/pages/app/mvp/create-session';
import { ToastContainer } from 'react-toastify';
import PackagesAndPayment from './views/pages/app/mvp/Payment/Packages-Payment';
import Payment from './views/pages/app/mvp/Payment/Payment';
import MyPackage from './views/pages/app/mvp/my-package';
import User from './views/pages/app/user';
import Appeal from './views/pages/app/mvp/appeal-detail';
import Profile from './views/pages/app/profile';
import SignUp from './views/mvpAuth/SignUp';
import Verification from './views/pages/app/Verification';
import { I18n, setLanguage } from './helpers/i18n';
import NavLanguage from './views/components/core/NavLanguage';
import { NotVerifiedModal } from 'views/components/core/modals';
const followUs = [
  { name: 'Discord', url: 'https://discord.gg/DM333x2M55', icon: discordIcon },
  { name: 'Facebook', url: 'https://www.facebook.com/KambriaNetwork', icon: facebookIcon },
  { name: 'Twitter', url: 'https://twitter.com/KambriaNetwork', icon: twitterIcon },
  { name: 'Linkedin', url: 'https://www.linkedin.com/company/kambria/', icon: linkedinIcon },
  { name: 'Youtube', url: 'https://www.youtube.com/channel/UCSVHcYVKbZQ4DRzuCItarrQ/featured', icon: youtubeIcon },
];

// const walletOptions = {
//   networkId: { ethereum: config.eth.NETWORK },
//   pageRefreshing: true,
// };

function HeaderApp({ blockchain, ui, user, history, connectWallet }) {
  const itemForSenior = { url: '/packages', title: I18n.t('packages'), exact: true };
  const navList = [
    { url: '/', title: I18n.t('home'), exact: true },
    { url: '/my-session', title: I18n.t('my_session'), exact: true },
    // { url: '/packages', title: 'Khám phá gói', exact: true }
  ];
  const [showNotVerifiedModal, setShowNotVerifiedModal] = useState(false);

  const handleCreateSessionClick = (e) => {
    if (user && user.type === 'seniorBuddy' && user.statusVerify !== 'verified') {
      e.preventDefault();
      setShowNotVerifiedModal(true);
    }
  };

  return (
    <section className="App__header">
      <Header logo={{ image: logo, url: 'https://kambria.io' }}>
        <Nav>
          {navList.map((item, index) => (
            <NavItem key={index} item={item} />
          ))}
          {user && user.type == 'seniorBuddy' && (
            <li>
              <Link to="/my-topic">{I18n.t('my_topic')}</Link>
            </li>
          )}
          {user && user.type == 'senior' && <NavItem key="10000" item={itemForSenior} />}
          <NavLanguage history={history} />
          {user && user.type == 'seniorBuddy' && (
            <li>
              <Link
                className={`btn-create-session${user.statusVerify !== 'verified' ? ' btn-disabled' : ''}`}
                to="/create-session"
                onClick={handleCreateSessionClick}
              >
                {I18n.t('create_session')}
              </Link>
            </li>
          )}
          {user.loading ? (
            <li>
              <CircleLoader style={{ marginTop: 12 }} />
            </li>
          ) : user.authenticated ? (
            <NavProfile history={history} blockchain={blockchain} />
          ) : (
            <li>
              <Link className="btn btn-secondary btn-sm btn-login" to="/login">
                {I18n.t('login')}
              </Link>
            </li>
          )}
        </Nav>
        {ui.status === 'loading' && <PageLoader type="top" />}
      </Header>
      <NotVerifiedModal
        visibleModal={showNotVerifiedModal}
        closeModal={() => setShowNotVerifiedModal(false)}
      />
    </section>
  );
}

config.init();

function App({ blockchain, user, ui, mvpRefreshToken, connectWallet, watchInfo, fetchUserMvp, mvp, getListLanguage }) {
  const [loading, setLoading] = useState(false);
  const userData = localStorage.getItem('user-info');
  const userStorage = userData ? JSON.parse(userData) : null;

  const getCurrentUserMvp = useCallback(
    () =>
      fetchUserMvp((user) => {
        console.log('user', user);
      }),
    [fetchUserMvp],
  );
  const doneWallet = (er) => {
    connectWallet(false);
    if (er) return console.error(er);
    return watchInfo();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!userStorage) {
          setLoading(true);
          await mvpRefreshToken();
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    };

    fetchData();
  }, [userStorage]);

  useEffect(() => {
    getCurrentUserMvp();
    document.getElementsByTagName('body')[0].style.height = '100%';
  }, [getCurrentUserMvp]);

  useEffect(() => {
    getListLanguage();
    let language = localStorage.getItem('language') || 'vi';
    if (user?.language) {
      language = user.language.value ?? user.language;
    }
    setLanguage(language);
  }, [user.language, user.accessToken]);

  const headerProps = { blockchain, user, ui, connectWallet, mvp };
  const commonProps = {
    header: <HeaderApp {...headerProps} />,
    footer: (
      <Footer>
        <FollowUs data={followUs} />
      </Footer>
    ),
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route exact key="/" path="/" render={(props) => <Home {...commonProps} {...props} />} />
          <Route exact key="/login" path="/login" render={(props) => <Login {...commonProps} {...props} />} />
          <Route exact key="/sign-up" path="/sign-up" render={(props) => <SignUp {...commonProps} {...props} />} />
          <Route exact key="/verification" path="/verification" render={(props) => <Verification {...commonProps} {...props} />} />
          <PrivateRoute exact key="/my-session" path="/my-session" component={MySession} commonProps={commonProps} />
          <PrivateRoute exact key="/my-topic" path="/my-topic" component={MyTopic} commonProps={commonProps} />
          <PrivateRouteSenior
            exact
            key="/packages"
            path="/packages"
            component={PackagesAndPayment}
            commonProps={commonProps}
          />
          <PrivateRouteSenior
            exact
            key="/payment/:id"
            path="/payment/:id"
            component={Payment}
            commonProps={commonProps}
          />
          <Route
            exact
            key="/session/:id"
            path="/session/:id"
            render={(props) => <DetailTopic {...commonProps} {...props} />}
          />
          <Route
            exact
            key="/session-detail/:id"
            path="/session-detail/:id"
            render={(props) => <SessionDetail {...commonProps} {...props} />}
          />
          <PrivateRoute exact key="/user" path="/user" component={User} commonProps={commonProps} />
          <PrivateRoute exact key="/user/:page" path="/user/:page" component={User} commonProps={commonProps} />
          <PrivateRoute
            exact
            key="/create-session"
            path="/create-session"
            component={CreateSession}
            commonProps={commonProps}
          />
          <PrivateRoute
            exact
            key="/update-session/:id"
            path="/update-session/:id"
            component={CreateSession}
            commonProps={commonProps}
          />
          <PrivateRoute
            exact
            key="/duplicate-session/:id"
            path="/duplicate-session/:id"
            component={CreateSession}
            commonProps={commonProps}
          />
          <PrivateRouteSenior
            exact
            key="/my-package"
            path="/my-package"
            component={MyPackage}
            commonProps={commonProps}
          />
          <PrivateRoute
            exact
            key="/accept-success/:id"
            path="/accept-success/:id"
            component={AcceptSession}
            commonProps={commonProps}
          />
          <PrivateRoute
            exact
            key="/decline-success/:id"
            path="/decline-success/:id"
            component={DeclineSession}
            commonProps={commonProps}
          />
          <PrivateRoute
            exact
            key="/session-video/:id"
            path="/session-video/:id"
            component={SessionVideoCustom}
            commonProps={commonProps}
          />
          <PrivateRoute exact key="/appeal/:id" path="/appeal/:id"
                        component={Appeal} commonProps={commonProps} />
          <Route render={(props) => <Error404 {...commonProps} {...props} />} />
        </Switch>
        <ToastContainer />
      </Suspense>
      {/* <Wallet visible={blockchain.visible} options={walletOptions} done={doneWallet} /> */}
    </>
  );
}

const mapStateToProps = ({ blockchain, ui, user, mvp }) => ({ blockchain, ui, user, mvp });
const mapDispatchToProps = {
  fetchUser,
  getKarma,
  linkProvider,
  connectWallet,
  watchInfo,
  getCredits,
  logInMvp,
  fetchUserMvp,
  getListLanguage,
  mvpRefreshToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
